module.exports = __webpack_public_path__ + "img/7.7264ee3c.jpg";